import { Injectable, Inject } from '@angular/core';
import { IUserIdFormat } from './iuser-id-format';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UserIdFormatService {
    uri = `${environment.apiLocation}/UserIDFormat`;
    constructor(
        @Inject(HttpClient) private http: HttpClient,
        @Inject(LoggingService) private log: LoggingService
    ) {}
    get(): Observable<Array<IUserIdFormat>> {
        return this.http.get<Array<IUserIdFormat>>(this.uri).pipe(
            tap(res =>
                this.log.verbose({
                    type: 'UserIdFormatService:reponse',
                    res
                })
            )
        );
    }
}
